export default "__VITE_ASSET__BfBou0fW__"